
import { useEffect } from "react";
import { Card } from "@/components/ui/card";
import AuthForm from "@/components/auth/AuthForm";
import { useAuth } from "@/context/SafeAuthProvider";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useSettings } from "@/context/SettingsContext";
import UnstuckLogo from "@/components/UnstuckLogo";

const Auth = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { darkMode } = useSettings();

  useEffect(() => {
    // Redirect to dashboard if already authenticated
    if (user && !loading) {
      navigate("/dashboard");
    }
  }, [user, loading, navigate]);

  // Don't render anything while checking authentication to prevent flashing
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#6127A0]"></div>
    </div>;
  }

  return (
    <div className={cn(
      "min-h-screen flex flex-col items-center justify-center p-4 font-montserrat transition-colors duration-300",
      darkMode 
        ? "bg-gradient-to-br from-[#1a0930] to-[#3F2E46] text-[#FBF3F1]" 
        : "bg-gradient-to-br from-[#FBF3F1] to-[#D896A4]/10"
    )}>
      <div className="w-full max-w-md mb-8">
        <UnstuckLogo className="mx-auto" textSize="lg" showTagline={true} />
      </div>
      
      <Card className={cn(
        "w-full max-w-md shadow-lg border backdrop-blur-sm p-8",
        darkMode 
          ? "bg-[#2d1a45]/80 border-[#6127A0]/30 text-[#FBF3F1]" 
          : "bg-white/90 border-[#D896A4]/10"
      )}>
        <AuthForm />
      </Card>
      
      <footer className={cn(
        "mt-8 text-center text-sm",
        darkMode ? "text-[#D896A4]" : "text-[#003F6B]"
      )}>
        <p>Unstuck: A journaling prompt generator</p>
        <p className={cn("mt-1", darkMode ? "text-[#D896A4]" : "text-[#003F6B]")}>
          Built with ❤️ by <a 
            href="https://ameliastewart.co" 
            target="_blank" 
            rel="noopener noreferrer"
            className={cn(
              "hover:underline transition-colors",
              darkMode 
                ? "text-[#AE78F0] hover:text-[#c096ff]" 
                : "text-[#6127A0] hover:text-[#4d1f80]"
            )}
          >
            Amelia Stewart
          </a>
        </p>
      </footer>
    </div>
  );
};

export default Auth;
